export{e as addIcons}from"./chunk-24aa46be.js";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/projects/rdav/web/app/themes/rdav/node_modules/ionicons/dist/esm/es5/build/index.js
// module id = 6
// module chunks = 0